exports = module.exports = require("./../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".bordered-canvas {\n    border: 1px solid hsl(0, 0%, 75%);\n}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./src/canvas.css
 ** module id = 104
 ** module chunks = 0
 **/